import { render, staticRenderFns } from "./DataSourceTable.vue?vue&type=template&id=f5a28c42&"
import script from "./DataSourceTable.vue?vue&type=script&lang=ts&"
export * from "./DataSourceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports